// Blushi-Skin Theme - Cart JavaScript (Shopify Native)
(function() {
  'use strict';

  // Show cart toast notification
  function showCartToast(productTitle) {
    var existingToast = document.querySelector('.cart-toast');
    if (existingToast) existingToast.remove();

    var toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><span>' + (productTitle ? productTitle + ' added to Ritual' : 'Added to Ritual') + '</span><button class="cart-toast-view" onclick="if(window.openCartDrawer)window.openCartDrawer();this.parentElement.remove();">View Cart</button>';

    if (!document.getElementById('cart-toast-styles')) {
      var styles = document.createElement('style');
      styles.id = 'cart-toast-styles';
      styles.textContent = '.cart-toast{position:fixed;top:100px;left:50%;transform:translateX(-50%);display:flex;align-items:center;gap:12px;background-color:hsl(var(--color-cream));border:1px solid hsl(var(--color-sage));border-radius:8px;padding:14px 20px;box-shadow:0 10px 40px -10px rgba(0,0,0,0.15);z-index:9999;animation:cartToastSlide 0.3s ease,cartToastFade 0.3s ease 3.7s forwards}.cart-toast svg{color:hsl(var(--color-sage));flex-shrink:0}.cart-toast span{font-family:var(--font-body);font-size:14px;color:hsl(var(--color-charcoal))}.cart-toast-view{font-family:var(--font-body);font-size:13px;font-weight:500;color:hsl(var(--color-sage));background:none;border:none;cursor:pointer;padding:4px 8px;margin-left:4px;border-radius:4px;transition:background 0.2s}.cart-toast-view:hover{background:hsl(var(--color-sage)/0.1)}@keyframes cartToastSlide{from{opacity:0;transform:translateX(-50%) translateY(-20px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}@keyframes cartToastFade{to{opacity:0;visibility:hidden}}';
      document.head.appendChild(styles);
    }

    document.body.appendChild(toast);
    setTimeout(function() { if (toast.parentElement) toast.remove(); }, 4000);
  }

  // Expose toast globally
  window.showCartToast = showCartToast;

  // Add to cart functionality using Shopify AJAX API (with event delegation for dynamic elements)
  function initAddToCart() {
    document.addEventListener('click', function(e) {
      var button = e.target.closest('[data-add-to-cart]');
      if (!button) return;
        e.preventDefault();
        e.stopPropagation();
        
      e.preventDefault();
      e.stopPropagation();
      
      var variantId = button.dataset.variantId;
      if (!variantId) return;

      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(response) {
          if (!response.ok) throw new Error('Failed to add to cart');
          return response.json();
        })
      .then(function(item) {
        updateCartCount();
        button.textContent = 'Added!';
        // Show toast and refresh cart drawer
        showCartToast(item.product_title);
        if (typeof window.afterAddToCart === 'function') {
          window.afterAddToCart();
        }
        setTimeout(function() {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
        button.textContent = 'Error';
        setTimeout(function() {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      });
    });
  }

  // Product form submission
  function initProductForms() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        var submitButton = form.querySelector('[type="submit"]');
        if (!submitButton) return;
        
        var originalText = submitButton.textContent;
        submitButton.disabled = true;
        submitButton.textContent = 'Adding...';

        var formData = new FormData(form);
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) {
          if (!response.ok) throw new Error('Failed to add to cart');
          return response.json();
        })
        .then(function(item) {
          updateCartCount();
          submitButton.textContent = 'Added to Ritual!';
          // Show toast and refresh cart drawer
          showCartToast(item.product_title);
          if (typeof window.afterAddToCart === 'function') {
            window.afterAddToCart();
          }
          setTimeout(function() {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }, 2000);
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          submitButton.textContent = 'Error';
          setTimeout(function() {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }, 2000);
        });
      });
    });
  }

  // Update cart count in header
  function updateCartCount() {
    fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var cartCount = document.querySelector('[data-cart-count]');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(function(error) {
        console.error('Error fetching cart:', error);
      });
  }

  // Expose updateCartCount globally
  window.updateCartCount = updateCartCount;

  // Initialize
  function init() {
    initAddToCart();
    initProductForms();
    updateCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
